import { useNavigate } from 'react-router-dom';
import { Copa2026Logo } from './Copa2026Logo';
import styles from './Header.module.css';

interface HeaderProps {
  unreadCount?: number;
}

export function Header({ unreadCount = 0 }: HeaderProps) {
  const navigate = useNavigate();

  return (
    <header className={styles.header}>
      <div className={styles.logo}>
        <Copa2026Logo size={36} />
        <span>Bolão Copa 2026</span>
      </div>

      <button
        type="button"
        className={styles.bellButton}
        onClick={() => navigate('/notificacoes')}
        aria-label={
          unreadCount > 0
            ? `Notificações — ${unreadCount} não lidas`
            : 'Notificações'
        }
      >
        <span className={styles.bellIcon} aria-hidden="true">
          🔔
        </span>
        {unreadCount > 0 && (
          <span className={styles.badge} aria-hidden="true">
            {unreadCount > 99 ? '99+' : unreadCount}
          </span>
        )}
      </button>
    </header>
  );
}
